module.exports = __webpack_public_path__ + "img/prod-1.097162af.png";